// Auto-généré depuis departementsArtsDivData.js par /app/scripts/split_departement_data.js
// NE PAS ÉDITER À LA MAIN — régénère via le script.

const data = {
  "code": "75",
  "name": "Paris",
  "slug": "75-paris",
  "prefecture": "Paris",
  "prefectureSlug": "paris",
  "region": "Île-de-France",
  "postalCode": "75000",
  "geo": {
    "lat": "48.8566",
    "lng": "2.3522"
  },
  "inDept": "Paris",
  "deptArticle": "Paris (75)",
  "nameWithArticle": "Paris",
  "h1Prefix": "Voyants & Médiums dans",
  "numPros": 35,
  "villes": [
    "Paris",
    "Boulogne-Billancourt",
    "Saint-Denis",
    "Argenteuil",
    "Montreuil",
    "Nanterre",
    "Vitry-sur-Seine",
    "Créteil",
    "Courbevoie",
    "Versailles"
  ],
  "villesFAQ": [
    "Marais",
    "Montmartre",
    "Saint-Germain-des-Prés"
  ],
  "voisins": [
    {
      "code": "92",
      "name": "Hauts-de-Seine (Nanterre)",
      "slug": "92-hauts-de-seine"
    },
    {
      "code": "93",
      "name": "Seine-Saint-Denis (Bobigny)",
      "slug": "93-seine-saint-denis"
    },
    {
      "code": "94",
      "name": "Val-de-Marne (Créteil)",
      "slug": "94-val-de-marne"
    },
    {
      "code": "91",
      "name": "Essonne (Évry)",
      "slug": "91-essonne"
    },
    {
      "code": "95",
      "name": "Val-d'Oise (Pontoise)",
      "slug": "95-val-d-oise"
    },
    {
      "code": "78",
      "name": "Yvelines (Versailles)",
      "slug": "78-yvelines"
    }
  ],
  "storytelling1": "Le département de <strong>Paris (75)</strong>, cœur battant de l'<strong>Île-de-France</strong>, est un territoire d'une intensité unique où l'histoire de France s'est écrite sur chaque pierre, de Notre-Dame aux Champs-Élysées. De <strong>Paris</strong>, ville lumière et capitale mondiale de l'art, de la mode et de la culture, avec ses monuments emblématiques comme la Tour Eiffel, le Louvre et le Sacré-Cœur, aux quartiers mystérieux du Marais et de Montmartre où artistes et visionnaires ont trouvé l'inspiration, en passant par les jardins du Luxembourg et les berges de la Seine classées au patrimoine mondial, cette ville aux mille visages inspire les voyants et médiums par son énergie cosmopolite et sa puissance tellurique. Paris, avec ses catacombes secrètes, ses passages couverts et son aura mystique, abrite des praticiens dont les dons sont amplifiés par la concentration des énergies et la diversité des influences culturelles du monde entier.",
  "storytelling2": "Consulter un voyant à Paris, c'est bénéficier d'une énergie cosmopolite et tellurique, façonnée par deux millénaires d'histoire et la convergence des cultures du monde. Les monuments emblématiques, les jardins secrets et les passages couverts créent un environnement propice à la méditation et à la clairvoyance. Les praticiens de Paris, du Marais à Montmartre, vous accompagnent avec passion et discernement dans vos questionnements, portés par la puissance vibratoire de la capitale et la richesse de ses énergies multiples."
};

export default data;
